<template>
	<div style="width: 100%;height: calc(100vh - 60px);">
		<PageHeader @back="goback" :content="'设置'" />
		
		<div class="settings-content">
			<div class="settings-section">
				<div class="section-header">
					<div class="section-title">
						<i class="el-icon-monitor"></i>
						<span>面访设置</span>
					</div>
				</div>
				
				<div class="settings-list">
					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">
								启用录音:
							</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.isBanModifyPhone" @change="onSubmit"></el-switch>
						</div>
					</div>
					
					<!-- <div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">启用拍照:</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.isHidePhone" @change="onSubmit"></el-switch>
						</div>
					</div> -->
					
					
					<div class="setting-item">
						<div class="setting-info">
							<div class="setting-title">启用定位:</div>
						</div>
						<div class="setting-control">
							<el-switch v-model="form.accessprotModifySample" @change="onSubmit"></el-switch>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="quotaBox">
			<el-form ref="form" :model="form" label-width="200px">
				<el-form-item label="启用录音:"><el-switch v-model="form.isBanModifyPhone"></el-switch></el-form-item>
				<el-form-item label="启用拍照:"><el-switch v-model="form.isHidePhone"></el-switch></el-form-item>
				<el-form-item label="启用定位:"><el-switch v-model="form.accessprotModifySample"></el-switch></el-form-item>
				

				<el-form-item><el-button type="primary" @click="onSubmit">确定</el-button></el-form-item>
			</el-form>
		</div> -->
	</div>
</template>

<script>
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		PageHeader
	},
	data() {
		return {
			id: '',
			form: {}
		};
	},
	created() {
		this.id = this.$route.query.id;
		this.loadData();
	},
	methods: {
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryControllerProperty}?id=${this.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						console.log(res.resultBody);
						let systemSetup = {
							id: res.resultBody.id, //问卷id
							content: res.resultBody.content, //问卷描述
							wjTitle: res.resultBody.wjTitle, //问卷标题
							accessprotModifySample: res.resultBody.accessprotModifySample == 0 ? false : true, //访问端可修改样本(0不可以，1可以修改)
							isBanModifyPhone: res.resultBody.isBanModifyPhone == 0 ? false : true, //是否禁止修改拨打电话(0不禁止，1禁止)
							isHidePhone: res.resultBody.isHidePhone == 0 ? false : true, //是否隐藏电话(0不隐藏，1隐藏)
							isEnableAppointmentMinuteHint: res.resultBody.isEnableAppointmentMinuteHint == 0 ? false : true, //是否启用约访分钟数提示(0不开启，1开启)
							appointmentMinuteSum: res.resultBody.appointmentMinuteSum, //提示分数数
							isEnableCallControl: res.resultBody.isEnableCallControl == 0 ? false : true, //是否启用拨打控制(0不开启，1开启)
							callControlSum: res.resultBody.callControlSum, //拨打控制最多拨打次数
							isPutSampleReadIntervalTime: res.resultBody.isPutSampleReadIntervalTime == 0 ? false : true, //是否开启放回样本可读取间隔时间(0不开启，1开启)
							putSampleReadIntervalTimeSum: res.resultBody.putSampleReadIntervalTimeSum ,//放回样本可读取间隔时间数
							dialsearchtype:res.resultBody.dialsearchtype//坐席绑定方式
						};
						that.form = systemSetup;
						console.log(systemSetup);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		onSubmit() {
			let data = {
				id: this.form.id, //问卷id
				// content: this.form.content, //问卷描述
				// wjTitle: this.form.wjTitle, //问卷标题
				accessprotModifySample: this.form.accessprotModifySample == false ? 0 : 1, //访问端可修改样本(0不可以，1可以修改)
				isBanModifyPhone: this.form.isBanModifyPhone == false ? 0 : 1, //是否禁止修改拨打电话(0不禁止，1禁止)
				isHidePhone: this.form.isHidePhone == false ? 0 : 1, //是否隐藏电话(0不隐藏，1隐藏)
				isEnableAppointmentMinuteHint: this.form.isEnableAppointmentMinuteHint == false ? 0 : 1, //是否启用约访分钟数提示(0不开启，1开启)
				appointmentMinuteSum: this.form.appointmentMinuteSum, //提示分数数
				isEnableCallControl: this.form.isEnableCallControl == false ? 0 : 1, //是否启用拨打控制(0不开启，1开启)
				callControlSum: this.form.callControlSum, //拨打控制最多拨打次数
				isPutSampleReadIntervalTime: this.form.isPutSampleReadIntervalTime == false ? 0 : 1, //是否开启放回样本可读取间隔时间(0不开启，1开启)
				putSampleReadIntervalTimeSum: this.form.putSampleReadIntervalTimeSum ,//放回样本可读取间隔时间数
				dialsearchtype: this.form.dialsearchtype//坐席绑定方式
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.modifyControllerProperty}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style lang="scss" scoped>
.settings-content {
	width: 1000px;
	margin: 0 auto;
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	overflow: hidden;
}
.settings-section {
	padding: 0;
	border-bottom: 1px solid #ebeef5;
}

.settings-section:last-child {
	border-bottom: none;
}

.section-header {
	padding: 20px 24px;
	background: #fafbfc;
	border-bottom: 1px solid #ebeef5;
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	display: flex;
	align-items: center;
	gap: 8px;
}
.settings-list {
	padding: 0;
}

.setting-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 24px;
	border-bottom: 1px solid #f0f2f5;
	transition: background-color 0.2s;
}

.setting-item:hover {
	background-color: #fafbfc;
}

.setting-item:last-child {
	border-bottom: none;
}

.setting-info {
	flex: 1;
	min-width: 0;
}

.setting-title {
	font-size: 14px;
	font-weight: 500;
	color: #303133;
	margin-bottom: 4px;
}

.setting-desc {
	font-size: 13px;
	color: #909399;
	line-height: 1.4;
}

.setting-control {
	margin-left: 20px;
	min-width: 120px;
	text-align: right;
	font-size: 14px;
}
</style>
